import Overlay from './Overlay';
import OverlayBody from './OverlayBody';
import OverlayContent from './OverlayContent';

export {
    OverlayBody,
    OverlayContent
};

export default Overlay;
